module.exports = "images/doc-currency-add.d029a112222daf16067bb003b9f6b824.png";